import * as Yup from 'yup';

export const emailValidator = Yup.string()
  .email('Must be a valid email address')
  .required('Email address is required');
